import { useEffect } from 'react';

export interface BreadcrumbItem {
  name: string;
  /** Omit `item` on the last (current) crumb — Google treats it as the current page */
  item?: string;
}

interface Props {
  crumbs: BreadcrumbItem[];
}

const BASE = 'https://adventive.com';

/**
 * Injects a JSON-LD BreadcrumbList script into <head> for Google Search.
 * Cleans up on unmount so navigating between pages doesn't leave stale tags.
 */
const BreadcrumbJsonLd: React.FC<Props> = ({ crumbs }) => {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs.map((crumb, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: crumb.name,
        ...(crumb.item ? { item: crumb.item.startsWith('http') ? crumb.item : `${BASE}${crumb.item}` } : {}),
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'breadcrumb-jsonld';
    script.textContent = JSON.stringify(schema);

    // Remove any existing breadcrumb tag before inserting
    document.getElementById('breadcrumb-jsonld')?.remove();
    document.head.appendChild(script);

    return () => {
      document.getElementById('breadcrumb-jsonld')?.remove();
    };
  }, [crumbs]);

  return null;
};

export default BreadcrumbJsonLd;
